export default {"src":"/_next/static/media/shield.b505d232.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};